const guiColors = {
    'motion-primary': 'oklab(0.59 0.11 -0.15)',
    'motion-primary-transparent': 'oklab(0.59 0.11 -0.15 / 0.75)',
    'motion-tertiary': 'oklab(0.50 0.12 -0.16)',

    'looks-secondary': 'oklab(0.59 0.11 -0.15)',
    'looks-transparent': 'oklab(0.59 0.11 -0.15 / 0.35)',
    'looks-light-transparent': 'oklab(0.59 0.11 -0.15 / 0.15)',
    'looks-secondary-dark': 'oklab(0.48 0.12 -0.16)',

    'extensions-primary': 'oklab(0.94 -0.06 0.18)',
    'extensions-tertiary': 'oklab(0.59 0.11 -0.15)',
    'extensions-transparent': 'oklab(0.94 -0.06 0.18 / 0.35)',
    'extensions-light': 'oklab(0.85 0.04 -0.08)',

    'drop-highlight': 'oklab(0.94 -0.06 0.18)',

    'menu-bar-background-image':
        'linear-gradient(90deg, ' +
        'oklab(0.94 -0.06 0.18 / 0.75) 0%, ' +
        'oklab(1.00 0.00 0.00 / 0.75) 33%, ' +
        'oklab(0.59 0.11 -0.15 / 0.75) 66%, ' +
        'oklab(0.29 0.00 0.00 / 0.75) 100%)'
};

const blockColors = {
    checkboxActiveBackground: 'oklab(0.59 0.11 -0.15)',
    checkboxActiveBorder: 'oklab(0.94 -0.06 0.18)'
};

export {
    guiColors,
    blockColors
};
